var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.7849 9.86667C10.3004 9.86667 10.7182 9.4488 10.7182 8.93333C10.7182 8.41787 10.3004 8 9.7849 8C9.26943 8 8.85156 8.41787 8.85156 8.93333C8.85156 9.4488 9.26943 9.86667 9.7849 9.86667Z",
    fill: "#009B94"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.81979 10.3999C9.21146 10.3999 7.99479 10.6999 7.95312 11.2999C8.36979 11.8916 9.05312 12.2749 9.81979 12.2749C10.5865 12.2749 11.2698 11.8916 11.6865 11.2999C11.6448 10.6999 10.4281 10.3999 9.81979 10.3999Z",
    fill: "#009B94"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 5.663V2.289L5.25 0L0 2.289V5.726C0 8.904 2.24 11.879 5.25 12.6C5.635 12.509 6.006 12.376 6.37 12.215C7.126 13.293 8.379 14 9.8 14C12.117 14 14 12.117 14 9.8C14 7.721 12.488 5.999 10.5 5.663ZM5.6 9.8C5.6 10.192 5.656 10.577 5.761 10.934C5.593 11.011 5.425 11.088 5.25 11.144C3.031 10.444 1.4 8.176 1.4 5.726V3.206L5.25 1.526L9.1 3.206V5.663C7.112 5.999 5.6 7.721 5.6 9.8ZM9.8 12.6C8.253 12.6 7 11.347 7 9.8C7 8.253 8.253 7 9.8 7C11.347 7 12.6 8.253 12.6 9.8C12.6 11.347 11.347 12.6 9.8 12.6Z",
    fill: "#009B94"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.b9b21177c76e12eab3f9a1c550b7411a.svg";
export { ForwardRef as ReactComponent };